import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { EmptyResponseEntity } from '~client/model/empty-response-entity';
import { ResponseEntity } from '~client/model/response-entity';
import { TokenAssignmentCreateResponse } from '~client/model/token-assignment-create-response';
import { TokenAssignmentGroupResponse } from '~client/model/token-assignment-group-response';
import { TokenAssignmentRequest } from '~client/model/token-assignment-request';
import { TokenAssignmentResendResponse } from '~client/model/token-assignment-resend-response';

/* User APIs pertaining to the assignmentState and transfer of tokens to other users */
export class TokenAssignmentController extends BaseController {
  /* Confirms the token assignmentState for a user */
  public confirmToken$(assignmentString: string): Observable<TokenAssignmentGroupResponse> {
    return this.get$('/tokenAssignment/confirm', { assignmentString });
  }

  /* Creates a token assignment for a user and sends the assignee notifications */
  public createTokenAssignment$(
    request: TokenAssignmentRequest,
  ): Observable<TokenAssignmentCreateResponse> {
    return this.post$('/tokenAssignment/create', request);
  }

  /* Declines a token assignmentState made to the user */
  public declineToken$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/tokenAssignment/public/decline', { assignmentString });
  }

  /* Validates a token assignmentState made to the user */
  public validateToken$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/tokenAssignment/public/validate', { assignmentString });
  }

  /* Revokes a token */
  public revokeToken$(inventoryItemId: string): Observable<EmptyResponseEntity> {
    return this.del$('/tokenAssignment/revoke', { inventoryItemId });
  }

  /* Returns a token */
  public returnToken(inventoryItemId: string): Promise<EmptyResponseEntity> {
    return this.del('/tokenAssignment/return', { inventoryItemId });
  }

  /**
   * @deprecated use non-observable version
   */
  public returnToken$(inventoryItemId: string): Observable<EmptyResponseEntity> {
    return this.del$('/tokenAssignment/return', { inventoryItemId });
  }

  /* Edit the token assignment for a user */
  public editTokenAssignment$(
    request: TokenAssignmentRequest,
  ): Observable<TokenAssignmentCreateResponse> {
    return this.put$('/tokenAssignment/edit', request);
  }

  /* Sets the token as assigned to current user. */
  public selfAssignToken$(eventId: string, tokenId: string): Observable<EmptyResponseEntity> {
    return this.put$(`/tokenAssignment/selfAssign?eventId=${eventId}&tokenId=${tokenId}`);
  }

  public resendInvite(assignmentGroupId: string): Promise<TokenAssignmentResendResponse> {
    return this.put(`tokenAssignment/resend?assignmentGroupId=${assignmentGroupId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/token-assignment-controller.ts